/**
 * @param {object} error - the axios error object
 * @param {string} [errorMsg = ${envName} is required] - the error message to be displayed if the server error message is not found
 * @return {string} - the error message
 */
function getErrorMessage(error, defaultErrorMessage = "خطایی رخ داده است") {
	const errorMessage = error?.response?.data;

	switch (typeof errorMessage) {
		case "string": {
			return errorMessage?.length > 0 ? errorMessage : defaultErrorMessage;
		}

		case "object": {
			if (errorMessage?.message || errorMessage?.Message) {
				return errorMessage.message || errorMessage.Message;
			}
			return defaultErrorMessage;
		}

		default: {
			return defaultErrorMessage;
		}
	}
}

export default getErrorMessage;
